import { useState } from "react";

export function useRemountKey() {
  const [key, setKey] = useState(0);
  const remount = () => setKey((prev) => prev + 1);
  return { key, remount };
}
